import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  BASE_URL,
  paypalAccountLisnStatusUpdateApi,
} from "../../utils/Constants";
import { toast } from "react-toastify";

const PaypalConnectSuccess = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem("Token");
    axios
      .put(
        `${BASE_URL}${paypalAccountLisnStatusUpdateApi}`,
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        if (res.data && res.data.connected) {
          toast.success("Paypal connected successfully");
        } else {
          toast.warning("Paypal onboarding incomplete. Please complete it.");
          navigate("/profilenanny");
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.warning("Paypal onboarding incomplete. Please complete it.");
        navigate("/profilenanny");
      });
  }, []);
  return (
    <div className="pt-5 pb-4">
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div
          className="subscription-success-container"
          style={{ minHeight: "60vh", flexDirection: "column" }}
        >
          <div className="success-box">
            <h2 className="success-title">
              Thanks, your account setup is complete! You'll now receive
              payouts.
            </h2>
            <p className="success-message">
              Thank you for booking a nanny with us! Your reservation has been
              confirmed, and your nanny will be there as scheduled to provide
              quality care. We appreciate your trust in our service!
            </p>

            <div className="success-actions">
              <Link to="/profilenanny" className="btna btn-primarya">
                Go to Profile
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaypalConnectSuccess;
